<template>
  <v-layout align-start>
    <v-flex>
      <v-data-table
        :headers="headers"
        :items="catArea"
        :search="search"
        class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>Asigna Usuario a Area</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-text-field
              class="text-xs-center"
              v-model="search"
              append-icon="search"
              label="Busqueda"
              single-line
              hide-details
            >
            </v-text-field>
            <v-spacer></v-spacer>

            <!--/////////////*****/ DIALOG  -->
            <v-dialog
              v-model="dialog"
              fullscreen
              hide-overlay
              transition="dialog-bottom-transition"
            >
              <!-- <template v-slot:activator="{ on }">
                            <v-btn color="primary" 
                                dark v-on="on" 
                                @click="newItem"
                                outlined>Asignar grupo</v-btn>
                        </template> -->
              <v-card>
                <v-toolbar dark color="primary">
                  <v-btn icon dark @click="dialog = false">
                    <v-icon>close</v-icon>
                  </v-btn>
                  <v-toolbar-title
                    ><span class="headline"
                      >Asignar usuarios</span
                    ></v-toolbar-title
                  >
                  <v-spacer></v-spacer>
                  <!-- <v-btn class="ma-2" @click="Limpiar()" outlined color="indigo">Limpiar Controles</v-btn> -->
                  <v-spacer></v-spacer>
                  <v-toolbar-items>
                    <v-btn @click="saveChange" dark text>
                      Grabar
                    </v-btn>
                  </v-toolbar-items>
                </v-toolbar>
                <v-card flat>
                  <v-card-text>
                    <h2>{{ TituloNombre }}</h2>
                  </v-card-text>
                </v-card>

                <v-list three-line subheader>
                  <!-- <v-subheader><strong> Seleccione Tipo de grupo</strong></v-subheader> -->
                  <v-container fluid>
                    <v-row>
                      <v-col cols="8" sm="8" md="8">
                        <template>
                          <v-simple-table fixed-header>
                            <thead>
                              <tr>
                                <th class="text-left">Nombre</th>
                                <th class="text-left">NoEmpleado</th>
                                <th class="text-left">Correo</th>
                                <th class="text-left">Asignar</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(item, index) in catUsuario"
                                :key="index"
                              >
                                <td>{{ item.nombre }}</td>
                                <td>{{ item.noEmpleado }}</td>
                                <td>{{ item.correo }}</td>
                                <td>
                                  <v-container fluid @click="selectUser(item)">
                                    <v-checkbox
                                      v-model="item.vigencia"
                                      :value="item.vigencia"
                                    >
                                    </v-checkbox>
                                  </v-container>
                                </td>
                              </tr>
                            </tbody>
                          </v-simple-table>
                        </template>
                      </v-col>

                      <v-col cols="4" sm="4" md="4">
                        <template>
                          <v-simple-table fixed-header>
                            <thead>
                              <tr>
                                <th class="text-left">Nombre</th>
                                <th class="text-left">NoEmpleado</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(item, index) in selectUsers"
                                :key="index"
                              >
                                <td>{{ item.nombre }}</td>
                                <td>{{ item.noEmpleado }}</td>
                              </tr>
                            </tbody>
                          </v-simple-table>
                        </template>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-list>
              </v-card>
              <v-divider></v-divider>
            </v-dialog>
            <!--/////////////*****/END DIALOG  -->
          </v-toolbar>
        </template>
        <template v-slot:body="{ items }">
          <tbody>
            <tr v-for="(item, index) in items" :key="index">
              <td>
                <div>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn icon v-on="on">
                        <v-icon small class="mr-2" @click="select(item)">
                          pan_tool
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>Seleccionar</span>
                  </v-tooltip>
                </div>
              </td>
              <td>{{ item.descripcion }}</td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
  created() {
    this.listar();
  },
  data() {
    return {
      catArea: [],
      TituloNombre: "",
      catUsuario: [],
      selectArea: {},
      selectUsers: [],
      dialog: false,
      consultaDto: {
        Skip: 0,
        Take: 100,
        descending: true,
        sortBy: "",
        search: "",
        idUsuario: 0,
        extraParam: "",
      },
      headers: [
        { text: "Opciones", value: "opciones", sortable: false },
        { text: "Area", value: "descripcion", sortable: false },
      ],
      search: "",
      snackbar: false,
      snackbarcolor: "",
    };
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  methods: {
    listar() {
      let ctx = this;
      debugger;
      ctx.$store.dispatch('setIsBusy', true);
      ctx.$axios
        .post("api/Area/Get", ctx.consultaDto)
        .then((r) => {
          if (r.data.exito) {
            ctx.catArea = r.data.datos;
          }
          // this.$root.Mensaje(r.data.mensaje)
          ctx.$store.dispatch('setIsBusy', false);
        })
        .catch((e) => {
          console.log(e);
        });
    },
    select(item) {
      let ctx = this;
      ctx.selectArea = item;
      ctx.TituloNombre = item.descripcion;
      ctx.consultaDto.extraParam = item.idArea.toString();
      debugger;
      ctx.$store.dispatch('setIsBusy', true);
      ctx.$axios
        .post("api/UsuarioArea/Get", ctx.consultaDto)
        .then((r) => {
          if (r.data.exito) {
            ctx.catUsuario = [];
            ctx.selectUsers = [];
            ctx.catUsuario = r.data.datos;

            ctx.catUsuario.forEach((element) => {
              if (
                element.idCatArea == item.idArea &&
                element.vigencia == true
              ) {
                ctx.selectUsers.push(element);
              }
            });
          }
          ctx.$store.dispatch('setIsBusy', false);
        })
        .catch((e) => {
          console.log(e);
        });
      this.dialog = true;
    },
    saveChange() {
      let ctx = this;

      debugger;
      ctx.$store.dispatch('setIsBusy', true);
      
      var js = {
        "usuarioarea": ctx.selectUsers,
        "idCatArea": ctx.selectArea.idArea
      };

      ctx.$axios
        .post("api/UsuarioArea/Save", js)
        .then((r) => {
          if (r.data.exito) {
            // me.catUsuarioSuperior = r.data.datos
            // this.$root.Mensaje(r.data.mensaje);
          }
          ctx.$store.dispatch('setIsBusy', false);
        })
        .catch((e) => {
          console.log(e);
        });

      this.dialog = false;
    },
    selectUser(item) {
      debugger;
      let ctx = this;
      item.idCatArea = ctx.selectArea.idArea
      var elemento = ctx.selectUsers.find((d) => d.idUsuario == item.idUsuario);
      if (elemento === undefined && item.vigencia == true) {
        ctx.selectUsers.push(item);
      } else if (elemento.vigencia == false || elemento.vigencia == null) {
        var index = ctx.selectUsers.indexOf(elemento);
        ctx.selectUsers.splice(index, 1);
        // ctx.selectUsers.r(elemento);
      }
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
  },
};
</script>
